import React from "react";
import BaseModal from "../../components/ui/BaseModal";
import CloseIcon from "@mui/icons-material/Close";

const TechnicianPrivacyPolicy = ({ open, close }) => {
  return (
    <BaseModal
      className="-top-[200px] overflow-auto"
      open={open}
      close={close}
    >
      <div className="py-7 px-8 xl:w-[1000px] lg:w-[900px] sm:w-[700px] relative font-poppins">
        <div className="flex items-center justify-between border-b pb-1">
          <h6 className="text-dark font-normal">Privacy Policy</h6>
          <button
            onClick={() => close(false)}
            className="text-gray-500 hover:text-gray-800"
          >
            <CloseIcon className="text-2xl" onClick={() => close(false)} />
          </button>
        </div>
        <div className="mt-6 max-h-[65vh] overflow-y-auto pr-2 text-base leading-relaxed text-gray-700 space-y-4">
          <p className="font-normal text-sm">
            <span className="font-semibold">Effective Date :</span> 01/06/2020
          </p>
          <p className="font-normal text-sm">
            <span className="font-semibold">Last Updated :</span> 01/07/2025
          </p>

          <p className="font-normal text-sm">
            At <span className="font-semibold">Tech Domain</span>, we value your
            privacy and are committed to protecting the personal information you
            share with us. This Privacy Policy explains how we collect, use,
            store, disclose, and protect your personal data when you interact
            with our website, services, or employees. It also describes your
            rights and how you can exercise them.
          </p>
          <p className="border-b pb-4 font-normal text-sm">
            By using our website or services, you agree to the terms of this
            Privacy Policy.
          </p>

          <h6 className="font-medium text-dark mb-3">1. Who we Are</h6>
          <p className="font-normal text-sm">
            Tech Domain is IT Managed Services company operating globally. We
            offer on-site support for our customers. As part of our operations,
            we may collect and process personal data from individuals, clients,
            and website visitors worldwide.
          </p>

          <h6 className="font-medium text-dark mb-3">
            2. Information We Collect
          </h6>
          <p className="font-normal text-sm">
            We collect information to provide better services to all our users.
            This includes:
          </p>

          <p className="font-medium text-base text-dark">
            (i) Personal Information You Provide to Us Directly
          </p>
          <ul className="list-disc pl-6 space-y-1 font-normal text-sm">
            <li>Full name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Company name and job title</li>
            <li>Billing and shipping addresses</li>
            <li>
              Any additional information submitted through contact forms or
              service requests
            </li>
          </ul>

          <p className="font-medium text-base text-dark">
            (ii) Information Collected Automatically
          </p>
          <p className="font-normal text-sm">
            When you visit our website, we may collect certain information
            automatically through cookies and analytics tools:
          </p>
          <ul className="list-disc pl-6 space-y-1 font-normal text-sm">
            <li>IP address</li>
            <li>Browser type and version</li>
            <li>Device type</li>
            <li>Operating system</li>
            <li>Pages visited and time spent</li>
            <li>Referral source</li>
          </ul>

          <p className="font-medium text-base text-dark">
            (iii) Information for Third Parties
          </p>
          <p className="font-normal text-sm">
            We may receive information from:
          </p>
          <ul className="list-disc pl-6 space-y-1 border-b pb-4 font-normal text-sm">
            <li>Our business partners</li>
            <li>Public databases</li>
            <li>Marketing service providers</li>
            <li>
              Social media platforms (if you interact with our content there)
            </li>
          </ul>

          <h6 className="font-medium text-dark  mb-3">
            3. How we Use Your Information
          </h6>
          <p className="font-normal text-sm">
            We use the information we collect for various purposes, including:
          </p>
          <ul className="list-disc pl-6 space-y-1 border-b pb-4 font-normal text-sm">
            <li>To provide our products and services to you</li>
            <li>To personalize and enhance your user experience</li>
            <li>
              To communicate with you about service updates, support requests,
              or marketing promotions (with your consent)
            </li>
            <li>To process transactions and manage billing and payments</li>
            <li>To comply with legal or regulatory obligations</li>
            <li>To detect and prevent fraudulent or unauthorized activity</li>
          </ul>

          <h6 className="font-medium text-dark  mb-3">
            4. Legal Basis for Processing (for EU/UK Residents)
          </h6>
          <p className="font-normal text-sm">
            Under the General Data Protection Regulation (GDPR), we process your
            personal data based on one or more of the following legal bases:
          </p>
          <ul className="list-disc pl-6 space-y-1 border-b pb-4 font-normal text-sm">
            <li>Your consent</li>
            <li>
              The necessity of processing for the performance of a contract
            </li>
            <li>Compliance with a legal obligation</li>
            <li>
              Our legitimate interests (such as improving our services or
              marketing relevant products)
            </li>
          </ul>

          <h6 className="font-medium text-dark  mb-3">
            5. How We Share Your Information
          </h6>
          <p className="font-normal text-sm">
            We do not sell or rent your personal data to third parties. However,
            we may share your data with trusted third parties under strict
            confidentiality agreements including:
          </p>
          <ul className="list-disc pl-6 space-y-1 font-normal text-sm">
            <li>
              <span className="font-semibold">
                {" "}
                Service providers and vendors:{" "}
              </span>
              for web hosting, payment processing, IT support, analytics, or CRM
              tools
            </li>
            <li>
              <span className="font-semibold">Legal authorities: </span>when
              required to comply with legal obligations or respond to lawful
              requests
            </li>
            <li>
              <span className="font-semibold"> Business transfers: </span>in
              case of a merger, acquisition, or asset sale
            </li>
          </ul>
          <p className="border-b pb-4 font-normal text-sm">
            All third parties are required to process your data in accordance
            with this Privacy Policy and applicable data protection laws.
          </p>

          <h6 className="font-medium text-dark mb-3">
            6. International Data Transfers
          </h6>
          <p className="border-b pb-4 font-normal text-sm">
            Your information may be transferred to and processed in countries
            other than your own, including the United States, European Union,
            Australia, or others. We ensure all international transfers comply
            with relevant data protection laws and are secured with standard
            contractual clauses or equivalent legal safeguards.
          </p>

          <h6 className="font-medium text-dark  mb-3">7. Data Security</h6>
          <p className="font-normal text-sm">
            We implement strong technical and organizational measures to secure
            your personal information against loss, misuse, or unauthorized
            access. These include:
          </p>
          <ul className="list-disc pl-6 space-y-1 font-normal text-sm">
            <li>Encryption of data during transmission</li>
            <li>Access control and authentication mechanisms</li>
            <li>Secure servers and firewalls</li>
            <li>Staff training and awareness</li>
          </ul>
          <p className="border-b pb-4 font-normal text-sm">
            Despite our efforts, no method of transmission over the internet is
            100% secure.
          </p>

          <h6 className="font-medium text-dark  mb-3">8. Data Retention</h6>
          <p className="border-b pb-4 font-normal text-sm">
            Your information may be transferred to and processed in countries
            other than your own, including the United States, European Union,
            Australia, or others. We ensure all international transfers comply
            with relevant data protection laws and are secured with standard
            contractual clauses or equivalent legal safeguards.
          </p>

          <h6 className="font-medium text-dark  mb-3">
            9. Your Privacy Rights
          </h6>
          <p className="font-normal text-sm">
            Depending on your jurisdiction, you may have the following rights:
          </p>
          <ul className="list-disc pl-6 space-y-1 border-b pb-4 font-normal text-sm">
            <li>Access – Request a copy of your personal data</li>
            <li>Correction – Request to update or correct inaccuracies</li>
            <li>
              Deletion – Request to delete your data under certain conditions
            </li>
            <li>Restriction – Ask us to limit the processing of your data</li>
            <li>
              Objection – Object to the processing of your data for direct
              marketing or other reasons
            </li>
            <li>
              Data Portability – Request a copy of your data in a structured,
              machine-readable format
            </li>
            <li>
              Withdraw Consent – If we rely on your consent, you may withdraw it
              at any time
            </li>
          </ul>

          <h6 className="font-medium text-dark  mb-3">
            10. Cookies and Technologies
          </h6>
          <p className="font-normal text-sm">
            Our website uses cookies and similar technologies to:
          </p>
          <ul className="list-disc pl-6 space-y-1 font-normal text-sm">
            <li>Improve functionality and performance</li>
            <li>Understand user behavior</li>
            <li>Serve targeted advertising</li>
          </ul>
          <p className="border-b pb-4 font-normal text-sm">
            You can manage or disable cookies via your browser settings. For
            more details, refer to our [Cookie Policy].
          </p>

          <h6 className="font-medium text-dark mb-3">11. Children’s Privacy</h6>
          <p className="border-b pb-4 font-normal text-sm">
            Our services are not intended for individuals under the age of 13
            (or equivalent minimum age in your jurisdiction). We do not
            knowingly collect personal data from children. If we become aware
            we’ve collected data from a child without parental consent, we will
            delete it.
          </p>

          <h6 className="font-medium text-dark mb-3 ">
            12. Third-party Websites
          </h6>
          <p className="border-b pb-4 font-normal text-sm">
            Our website may contain links to third-party websites. We are not
            responsible for the privacy practices or content of those websites.
            Please read their privacy policies before submitting any
            information.
          </p>

          <h6 className="font-medium text-dark mb-3">
            13. Changes to this Privacy Policy
          </h6>
          <p className="border-b pb-4 font-normal text-sm">
            We may update this policy from time to time to reflect changes in
            our practices, technology, or legal requirements. Any updates will
            be posted on this page with a revised “Effective Date.” We encourage
            you to review the policy regularly.
          </p>

          <h6 className="font-medium text-dark mb-3">14. Account Deletion</h6>
          <p className="font-normal text-sm">
            <span>Steps to Delete an Account:</span>
          </p>
          <ol className="list-decimal pl-6 space-y-1 font-normal text-sm ">
            <li>The user must be logged in.</li>
            <li>Navigate to My Profile.</li>
            <li>Select Edit Profile.</li>
            <li>Scroll to the bottom of the page and tap on Delete Account.</li>
            <li>
              Confirm the action when prompted to permanently delete your
              account.
            </li>
          </ol>

          <p className="font-medium text-base text-dark">
            <span>(i) Consequences of Deleting an Account:</span>
          </p>
          <ul className="list-disc pl-6 space-y-1 font-normal text-sm">
            <li>
              All personal data, saved preferences, and activity history will be
              permanently deleted.
            </li>
            <li>You will no longer have access to your account.</li>
            <li>
              Any connected services or subscriptions linked to your account
              will be automatically cancelled.
            </li>
            <li>
              All in-app progress, messages, or uploaded content (if any) will
              be lost.
            </li>
          </ul>

          <p className="font-medium text-base text-dark">
            <span>(ii) Data Retention After Deletion:</span>
          </p>
          <ul className="list-disc pl-6 space-y-1 font-normal text-sm">
            <li>
              Retained data will not be used for marketing or shared with third
              parties.
            </li>
            <li>
              All retained data will be securely stored and automatically
              deleted after the required retention period.
            </li>
            <li>
              The standard retention period is 30 days in compliance with legal
              or regulatory obligations.
            </li>
            <li>
              Users may contact support to inquire about retention to their
              account.
            </li>
          </ul>

          <p className="font-medium text-base text-dark">
            <span>(iii) Legal Disclaimers:</span>
          </p>
          <ul className="list-disc pl-6 space-y-1 border-b pb-4 font-normal text-sm">
            <li>
              {" "}
              Certain data may be retained for a longer period if required by
              law (e.g., tax records, fraud investigations, or dispute
              resolution).
            </li>
            <li>
              {" "}
              This retention is in compliance with applicable legal, regulatory,
              or contractual obligations.
            </li>
            <li>
              {" "}
              Retained data will be securely stored and protected during the
              retention period.
            </li>
            <li>
              {" "}
              Once the legal retention period ends, the data will be permanently
              deleted.
            </li>
            <li>
              {" "}
              Users will not be able to access or request deletion of such
              legally retained data until the retention obligation is fulfilled.
            </li>
          </ul>

          <h6 className="font-medium text-dark  mb-3">15. Contact Us</h6>
          <div className="space-y-2 text-sm leading-relaxed text-gray-700">
            <p className="font-normal text-sm">
              If you have questions, concerns, or requests regarding this
              Privacy Policy or your data, please contact us at:
            </p>
            <p className="font-normal text-sm">
              <span className="font-semibold">Tech Domain</span>
            </p>
            <p className="font-normal text-sm">
              Email :{" "}
              <a
                href="mailto:Info@techdomain.com.au"
                className="text-primary font-normal text-sm"
              >
                Info@techdomain.com.au
              </a>
            </p>
            <p className="font-normal text-sm">
              Phone : <span className="font-semibold">+61 (02) 9158 3294</span>
            </p>
            <p className="font-normal text-sm">
              Address :{" "}
              <span className="font-semibold">
                14 St Mirren Avenue, North Kellyville, NSW, 2155, Australia
              </span>
            </p>
          </div>
        </div>
      </div>
    </BaseModal>
  );
};

export default TechnicianPrivacyPolicy;
